'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClient = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getClient = exports.getClient = (0, _getIn2.default)(['pubSubClient', 'data']);


//////////////////
// WEBPACK FOOTER
// ./js/pubsub/selectors/getClient.js
// module id = 139
// module chunks = 2 3